module.exports = __webpack_public_path__ + "static/media/puzzle-22-bg.207c930c.svg";